import React from "react";
import "./smallSpinner.css";

const Spinner = (props) => {
  return <div class="lds-dual-ring"></div>;
};

export default Spinner;
